import { Product } from "src/types/storefront";

export default function getOptionValues(product: Product, optionName: string) {
	return (
		product.options.find((item) => item.name === optionName)?.values || null
	);
}
